import * as t from "io-ts";
import { Either, flatten, map, mapLeft } from "fp-ts/lib/Either";
import { _Error } from "@/lib/wordpress/data";
import fpJsonParse from "@/util/fp-json-parse";
import { flow, pipe } from "fp-ts/lib/function";
import { iotsErrorsToCustomErrorType } from "@/util/io-ts-errors-to-_error";

/**
 * Does JSON parsing and IO-TS decoding of the parsing result.
 *
 * Example usage:
 *
 * fpJsonParseTypesafe('{"foo": "bar"}', t.typeof({foo: t.string}));
 */
export default function fpJsonParseTypesafe<
  IoTsType extends t.Type<IoTsTypeTypeOf>,
  IoTsTypeTypeOf = IoTsType extends t.Type<infer R> ? R : never
>(
  jsonWhichMightBeInvalid: string,
  ioTsType: IoTsType
): Either<_Error[], IoTsTypeTypeOf> {
  return pipe(
    jsonWhichMightBeInvalid,
    fpJsonParse,
    map(flow(ioTsType.decode, mapLeft(iotsErrorsToCustomErrorType))),
    flatten
  );
}
